import { Box, Text } from "@chakra-ui/react";
import { ButtonCarousel } from "../carousel/ButtonCarousel";
import { ComicLabelsProps } from "./types";
import { useComicLabels } from "./useComicLabels";

export function ComicLabelsCarousel({ comicData, labels: providedLabels }: ComicLabelsProps) {
  const extractedLabels = useComicLabels(comicData);
  const labels = providedLabels ?? extractedLabels;

  if (labels.length === 0) return null;

  return (
    <ButtonCarousel
      containerProps={{ whiteSpace: "nowrap" }}
      width="100%"
      onlyFade
    >
      {labels.map((label) => (
        <Box
          key={label}
          bg="transparent.white.10"
          borderRadius="full"
          py="8px"
          px="12px"
          width="fit-content"
          mr="6px"
          userSelect="none"
        >
          <Text
            fontFamily="Roboto"
            textAlign="center"
            fontSize="12px"
            lineHeight="14.06px"
            fontWeight="500"
            color="dune.700"
          >
            {label}
          </Text>
        </Box>
      ))}
    </ButtonCarousel>
  );
}
